import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=ed5e3500&"
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"
import style0 from "./notify.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports